import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaHeart } from 'react-icons/fa';
import { getCurrentTenant, getCurrentUser } from '../../redux/auth/authSlice';
import {
  getAvailableGetAllFavouriteProduct,
  toggleFavouriteRequest,
} from '../../redux/pos/posSlice';
import { toast } from 'react-toastify';

const FavoriteButton = ({ productId, item, darkMode }) => {
  const dispatch = useDispatch();

  // Selector Warning Fix: Ensure default empty array
  const allFavouriteProduct =
    useSelector(getAvailableGetAllFavouriteProduct) || [];
  const user = useSelector(getCurrentUser);
  const currentTenant = useSelector(getCurrentTenant);

  // ID Comparison Logic (Dono nesting levels check karein)
  const favItem = allFavouriteProduct.find(
    (fav) =>
      String(fav.productId) === String(productId) ||
      String(fav.favouriteProduct?.productId) === String(productId)
  );

  const isFav = !!favItem;

  const handleToggle = (e) => {
    e.preventDefault(); // Safety
    e.stopPropagation();

    if (!user) {
      toast.error('Please! Login First');
      return;
    }

    // ID nikalne ka sahi tariqa
    const entryId = isFav ? favItem.id ?? favItem.favouriteProduct?.id ?? 0 : 0;

    const payload = {
      id: Number(entryId),
      productId: Number(productId),
      tenantId: currentTenant?.id || null,
      userId: user?.referenceId,
      isDelete: isFav, // Agar pehle se fav hai to delete hoga
    };

    dispatch(toggleFavouriteRequest(payload));
  };

  return (
    <button
      className="btn position-absolute top-0 start-0 m-3 shadow-sm rounded-circle d-flex align-items-center justify-content-center"
      style={{
        zIndex: 10,
        width: '36px',
        height: '36px',
        backgroundColor: darkMode ? '#333' : '#fff',
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
      }}
      onClick={handleToggle}
      type="button"
    >
      <FaHeart
        style={{
          color: isFav ? '#e4002b' : '#ccc',
          transition: 'all 0.2s ease-in-out',
          fontSize: '18px',
          transform: isFav ? 'scale(1.2)' : 'scale(1)',
        }}
      />
    </button>
  );
};

export default FavoriteButton;
